import { cn } from "@/lib/utils";

// 공급사 로고(정사각 이미지 → 원형 크롭). 로고가 없으면 회사명에서 '주식회사' · '(주)' · '㈜'를 뺀 첫 글자 이니셜 (설계서 필드 매핑 #2).
export function initialOf(name: string) {
  return name.replace(/^(주식회사|\(주\)|㈜)\s*/, "").replace(/\s*(주식회사|\(주\)|㈜)$/, "").trim().slice(0, 1).toUpperCase();
}

export function SupplierLogo({ name, logoUrl, size, round = true, className }: { name: string; logoUrl?: string | null; size: number; round?: boolean; className?: string }) {
  const radius = round ? "rounded-full" : size >= 80 ? "rounded-[22px]" : "rounded-[7px]";
  if (logoUrl) {
    return <img src={logoUrl} alt="" width={size} height={size} className={cn("shrink-0 border border-nv-border bg-white object-contain", radius, className)} style={{ width: size, height: size }} />;
  }
  return (
    <span
      aria-hidden
      className={cn("flex shrink-0 items-center justify-center bg-[#2D2D2D] text-white", size >= 80 ? "font-normal" : "font-bold", radius, className)}
      style={{ width: size, height: size, fontSize: size >= 80 ? Math.round(size * 0.39) : Math.round(size * 0.46), lineHeight: 1 }}
    >
      {initialOf(name)}
    </span>
  );
}
